"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SingleAppointmentSelector = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _utils = require("../../utils");
var _ = require("./..");
var _utils2 = require("./utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useQuery = _utils.QueryUtils.useQuery;
var SingleAppointmentSelectorContent = function SingleAppointmentSelectorContent(props) {
  var clinicians = props.clinicians,
    value = props.value,
    duration = props.duration,
    onSelect = props.onSelect,
    initialDate = props.initialDate,
    _props$pageSize = props.pageSize,
    pageSize = _props$pageSize === void 0 ? 7 : _props$pageSize,
    _props$showOnlyManage = props.showOnlyManagedAvailability,
    showOnlyManagedAvailability = _props$showOnlyManage === void 0 ? true : _props$showOnlyManage;
  var _useQuery = useQuery(),
    replaceQuery = _useQuery.replaceQuery;
  var _useAuth = (0, _.useAuth)(),
    user = _useAuth.user;
  var _getDateRangeFromProp = (0, _utils2.getDateRangeFromProps)(user),
    start = _getDateRangeFromProp.start,
    end = _getDateRangeFromProp.end;
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    error = _useState2[0],
    setError = _useState2[1];
  var _useAvailableSlots = (0, _utils2.useAvailableSlots)({
      clinicians: clinicians,
      start: start,
      end: end,
      duration: duration,
      showOnlyManagedAvailability: showOnlyManagedAvailability,
      onError: function onError(error) {
        return setError(error);
      }
    }),
    slots = _useAvailableSlots.slots,
    loading = _useAvailableSlots.loading;
  var _useNotifyInvalidSlot = (0, _utils2.useNotifyInvalidSlot)({
      ready: !loading,
      slots: slots,
      value: value,
      onSelect: onSelect
    }),
    invalidSlotPending = _useNotifyInvalidSlot.pending;
  if (error) {
    return /*#__PURE__*/_react.default.createElement("p", {
      className: "p-[24px]"
    }, "There was a problem checking for available time slots. Please reload the page and try again.");
  }
  if (loading || invalidSlotPending) {
    return /*#__PURE__*/_react.default.createElement(_.SpinPlaceholder, null);
  }
  if (!slots || slots.length === 0) {
    var _clinicians$;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "pt-[24px] px-[24px]"
    }, /*#__PURE__*/_react.default.createElement(_.NoAvailabilitySupport, {
      clinicianType: (_clinicians$ = clinicians[0]) === null || _clinicians$ === void 0 ? void 0 : _clinicians$.role,
      handleDecline: function handleDecline() {
        return replaceQuery();
      }
    }));
  }
  return /*#__PURE__*/_react.default.createElement(_.TimeslotSelector, {
    slots: slots,
    onSelect: onSelect,
    value: value,
    initialDate: initialDate,
    pageSize: pageSize
  });
};
var NoClinicianCalendarsErrorMessage = function NoClinicianCalendarsErrorMessage(_ref) {
  var clinicians = _ref.clinicians;
  var _useAuth2 = (0, _.useAuth)(),
    user = _useAuth2.user;
  if ((0, _utils.isAdmin)(user)) {
    return /*#__PURE__*/_react.default.createElement("p", {
      className: "p-[24px]"
    }, "This clinician does not have a calendar connected. Please go to their settings and connect one to schedule appointments.");
  }
  if ((0, _utils.isClinician)(user)) {
    return /*#__PURE__*/_react.default.createElement("p", {
      className: "p-[24px]"
    }, "You do not have a calendar connected. Please visit your", ' ', /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
      to: "/availability/manage"
    }, "settings page"), " to connect one in order to book appointments.");
  }

  // Default user is patient
  var targetClinicianText = clinicians.length > 1 ? 'No clinicians in your state have' : 'Your clinician hasn’t';
  return /*#__PURE__*/_react.default.createElement("p", {
    className: "p-[24px]"
  }, targetClinicianText, " updated their availability. Please email", ' ', /*#__PURE__*/_react.default.createElement("a", {
    href: _utils.SUPPORT_URL
  }, "support@joinmonument.com"), " and we\u2019ll ensure you get an appointment scheduled as soon as possible.");
};

// Wrapper component for validating props and short-circuiting if necessary
var SingleAppointmentSelector = function SingleAppointmentSelector(props) {
  var noClinicianCalendars = props.clinicians.every(function (clinician) {
    return !clinician.cronofySub;
  });
  if (noClinicianCalendars) {
    return /*#__PURE__*/_react.default.createElement(NoClinicianCalendarsErrorMessage, {
      clinicians: props.clinicians
    });
  }
  return /*#__PURE__*/_react.default.createElement(SingleAppointmentSelectorContent, props);
};
exports.SingleAppointmentSelector = SingleAppointmentSelector;